import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrefixGroupsApiService {

  constructor(private http: HttpClient) { }

  private readonly prefixGroupsUrl: string = 'routing/attributeGroup';

  public getPrefixGroups(parameters = {}): Observable<any> {
    const generatedPrefixGroupsUrl = UrlQueryService.addQueryParameters(this.prefixGroupsUrl, parameters);

    return this.http.get(generatedPrefixGroupsUrl);
  }

  public getPrefixGroup(prefixGroupId): Observable<any> {
    return this.http.get(`${this.prefixGroupsUrl}/${prefixGroupId}`);
  }

  public editPrefixGroup(prefixGroup, prefixGroupId): Observable<any> {
    return this.http.put(`${this.prefixGroupsUrl}/${prefixGroupId}`, prefixGroup);
  }

  public getPrefixGroupsSlim(): Observable<any> {
    const parameters = {
      filter: {
        slim: {
          operator: '=',
          value: 'true'
        }
      }
    };

    return this.getPrefixGroups(parameters);
  }

  public addPrefixGroup(prefixGroup): Observable<any> {
    return this.http.post(this.prefixGroupsUrl, prefixGroup);
  }

  public deletePrefixGroups(ids): Observable<any> {
    const parameters = {
      filter: {
        id: {
          value: ids,
          operator: '='
        }
      }
    };
    const generatedPrefixGroupsUrl = UrlQueryService.addQueryParameters(this.prefixGroupsUrl, parameters);
    return this.http.delete(generatedPrefixGroupsUrl);
  }
}
